const DEFAULT_IDM_BASE = "https://idm.werbeauto.ch";
const KNOWN_APP_SUBDOMAINS = ["admin", "advertiser", "demo", "idm"];

const normalizeBaseUrl = (value) => {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized ? normalized.replace(/\/$/, "") : "";
};

const deriveIdmBaseFromHostname = (hostname, protocol) => {
  if (!hostname) {
    return "";
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "";
  }

  const segments = hostname.split(".").filter(Boolean);
  if (!segments.length) {
    return "";
  }

  const baseSegments =
    KNOWN_APP_SUBDOMAINS.includes(segments[0]) && segments.length > 1 ? segments.slice(1) : segments;

  if (!baseSegments.length) {
    return "";
  }

  return `${protocol}//idm.${baseSegments.join(".")}`;
};

const envBase = normalizeBaseUrl(process.env.REACT_APP_IDM_BASE_URL);
const runtimeBase =
  typeof window !== "undefined"
    ? deriveIdmBaseFromHostname(window.location.hostname, window.location.protocol)
    : "";

export const IDM_BASE_URL = envBase || runtimeBase || DEFAULT_IDM_BASE;
export const buildIdmUrl = (path = "") =>
  path ? `${IDM_BASE_URL}${path.startsWith("/") ? path : `/${path}`}` : IDM_BASE_URL;
